import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_PAGE_LIMIT,
  DiamIdentityFilter,
  diamQueryKeys,
  getIdentitiesPage,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useTeamMembers(teamId: string | undefined) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);
  const filter: DiamIdentityFilter = {
    teamId: teamId ?? '',
    teamScope: 'SINGLE',
  };

  return useQuery({
    queryKey: diamQueryKeys.identities(filter),
    queryFn: async () => {
      if (!teamId) {
        throw new Error('A team id is required');
      }

      const idToken = await getIdToken();
      return getIdentitiesPage(apiUrl, idToken, {
        page: 0,
        limit: DIAM_PAGE_LIMIT,
        filter: { teamId, teamScope: 'SINGLE' },
      });
    },
    enabled: isSignedIn && Boolean(teamId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
